import { BoardAncestorsDropdown } from '~/components/Workspace/BoardHeader/BoardCrumbs/BoardAncestorsDropdown';
import { type BoardCrumbsProps } from '~/components/Workspace/BoardHeader/BoardCrumbs/index';

type ShortBoardCrumbsProps = BoardCrumbsProps;

export const ShortBoardCrumbs = ({ onBoardClick, ancestors, title }: ShortBoardCrumbsProps) => (
  <div className="flex items-center gap-1">
    {ancestors.length ? (
      <>
        <BoardAncestorsDropdown ancestors={ancestors} onBoardClick={onBoardClick} />
        <span className="ads:text-metadata text-12 text-gray-8">/</span>
      </>
    ) : null}
    <div className="flex-1 truncate px-1 font-medium ads:text-secondary text-12 text-gray-11">{title}</div>
  </div>
);
